export const checkSupervisorPermission = (signatureAccess: object, documentType: string) => {
  const mappingTransitionalEval = {
    TRANSITIONAL_EVALUATION_REFORM_PT: 'EVALUATION_REFORM_PT',
    TRANSITIONAL_EVALUATION_REFORM_OT: 'EVALUATION_REFORM_OT',
    TRANSITIONAL_EVALUATION_REFORM_SLP: 'EVALUATION_REFORM_SLP',
  };

  if (!signatureAccess || !documentType) return false;

  // First check direct permission
  let checkPermission = Boolean(signatureAccess[documentType as keyof typeof signatureAccess]);

  // If no direct permission and it's a transitional evaluation, check mapped permission
  if (!checkPermission && documentType in mappingTransitionalEval) {
    const mappedType = mappingTransitionalEval[documentType as keyof typeof mappingTransitionalEval];
    checkPermission = Boolean(signatureAccess[mappedType as keyof typeof signatureAccess]);
  }

  if (checkPermission) {
    return true;
  } else {
    return false;
  }
};
